<div class="notification p-3">
    @if(!loader){
        @if(notifications && notifications.length){
            @for(item of notifications; track item){
                <div class="widget p-3 mb-3 notification__single d-flex justify-content-between align-items-center">
                    <div class="d-flex align-items-center">
                        @if(item.type === 'OUT OF MARKET'){
                            <i class="bi bi-bag-x notification__notTypeIcon notification__notTypeIcon--oom"></i>
                        }
                        @else if(item.type === 'NO LABEL'){
                            <i class="bi bi-upc-scan notification__notTypeIcon notification__notTypeIcon--nol"></i>
                        }
                        @else if(item.type === 'MISSING'){
                            <i class="bi bi-aspect-ratio notification__notTypeIcon notification__notTypeIcon--mpal"></i>
                        }
                        @else if(item.type === 'STORE'){
                            <i class="bi bi-shop notification__notTypeIcon notification__notTypeIcon--store"></i>
                        }
                        @else if(item.type === 'ERROR SHIP ADVICE' || item.type === 'SHIP ADVICE'){
                            <i class="bi bi-file-earmark-spreadsheet notification__notTypeIcon notification__notTypeIcon--shipAdvice"></i>
                        }
                        <p class="mb-0 notification__title ms-3">
                            @if(currentProfile === 0){
                                <b>{{item.orgId}} - </b>
                            }
                            
                            @if(item.transferId){
                                <!-- @if(((currentRole === 0 || currentRole === 1 || currentRole === 99) && (item.type === 'OUT OF MARKET' || item.type === 'NO LABEL') && item.transferCarrier !== 'FedEx')){
                                    <a href="javascript:void(0)" class="notification__anchor" (click)="download(item)">{{item.transferId}}</a>
                                }
                                @else {
                                    {{item.transferId}}
                                } -->
                                {{item.transferId}}
                            }
                            {{item.notificationDesc}}
                        </p>
                    </div>
                    <div class="d-flex align-items-center">
                        @if(item.action){
                            <button type="button" class="btn notification__transfer" (click)="goToTransfer(item)">Transfer</button>
                        }
                        @if(!(currentProfile === 0 && (item.type === 'OUT OF MARKET' || item.type === 'NO LABEL'))){
                            <button type="button" [title]="'Dismiss'" class="btn notification__close py-0" (click)="dismiss(item.id)">
                                <i class="bi bi-x-lg"></i>
                            </button>
                        }
                    </div>
                </div>
            }
        }
        @else {
            <p class="my-5 py-5 text-center">
                {{labels.noData}}
            </p>
        }
    }
    @else {
        <app-loader></app-loader>
    }
    
</div>